module.exports = __webpack_public_path__ + "img/abbie-bernet-04X58d_hHv8-unsplash.e62dff34.jpg";